import axios from "axios";
import CryptoJS from 'crypto-js';
import forge from 'node-forge';

// lsq lapp names for different cases
const lappNames = {
  OTP: "da_46725_9f5d7299",
  CREATE: "da_46725_c0ebcc55",
  MAVIS: "da_46725_27857182",
  CIBIL: "da_46725_2fb2df8c",
  CUSTOMER_SEARCH: "da_46725_a9bdc684",
  UPDATE_LEAD: "da_46725_89cae1b0",
  LOGGER: "da_46725_b60ab827",
  CRIF: "da_46725_db9e18ed",
  KARZA_MAIL: "da_46725_cb5bd367"
};

// lsq base URL
const LSQ_BASE_URL =
  "https://pstech.leadsquaredapps.com/lapp-proxy";

// call lsq api
export const callLSQLapp = async (payload, lappType, param) => {
  try {
    // console.log("payload, lappType, param", { payload, lappType, param });
    // create payload
    let proxyPayload = {
      method: "post",
      orgId: "46725",
      params: {
        stage: "Live",
        name: lappNames[lappType],
      },
      data: {
        lappBody: payload,
      },
    };

    // add params
    if (param) {
      const mergedObject = Object.assign({}, proxyPayload.params, param);
      proxyPayload.params = mergedObject;
    }
    // console.log("proxyPayload", proxyPayload);
    const res = await axios.post(LSQ_BASE_URL, proxyPayload);
    return res;
  } catch (error) {
    console.log("callLSQLapp error", error);
  }
};

export function getLsqLeadBody(formData, TypeOfLoan) {
  let Config = {
    subProduct: "mx_Subcategory_product",
    pincode: "mx_Pincode",
    token: "mx_Token",
    DateOfBirthValue: "mx_Date_of_Birth",
    firstname: "FirstName",
    lastname: "LastName",
    email: "EmailAddress",
    mobile: "Mobile",
    profession: "mx_Employment_Type",
    salary: "mx_Take_Home_Salary",
    // minloanamt: "mx_HL_Required_Loan_Amount",
    ApiProductName: "mx_Product",
    isChecked: "mx_Iauthorization",
    // ExistingObligations: "mx_Obligation_Amount",
    MonthlyIncome: "mx_Gross_Monthly_Income",
    salary_mode: "mx_Salary_Received_in_Cash",
    LoanTenure: "mx_Tenure_in_Years",
    co_applicant: "mx_CoApplicant",
    co_applicant_salary: "mx_Co_Applicant_Salary",
    loanamount: "mx_HL_Required_Loan_Amount",
    Obligation: "mx_Obligation_Amount",
    GrossFamilyIncome: "mx_Gross_Family_Income",

    PurposeOfLoan: "mx_Purpose",

    City: "mx_City",
    EducationQualification: "mx_HighestEducation_Qualification",

    DND: "mx_DND_NDNC",
    COMPANY_LOCATION: "mx_Customer_Location",

    Age: "mx_Age",
    gclid: "mx_Gclid",
    Referral: "mx_Referral",
    InterestRate: "mx_Interest_Rate",
    FOIR: "mx_FOIR",
    EligibilityReason: "mx_Eligibility_Reason",
    // EmiPerLakh: "mx_Offer_EMI",
    CompleteUrl: "mx_UTM_URL_Details",
    calTenure: "mx_Current_EMI",
    ApproximateCostOfProperty: "mx_Property_Value",
    // RequiredLoanAmount: "mx_Loan_Amount",
    PropertyIdentified: "mx_Property_Identified",
    CampaignId: "mx_Campaign_ID",
    ParentProduct: "mx_Parent_Product",
    displayLoanAmount: "mx_Offer_Amount",
    displayTenure: "mx_Current_EMI",
    displayEmiPayable: "mx_Offer_EMI",
    displayRate: "mx_Offer_Rate_of_Interest",
    cibilscore: "mx_cibil_score",
    incomeSegment: "mx_income_segment_score",
    reportId: "mx_Criff_Report_ID",
    FBClickID: "mx_FB_Click_ID",
    FBPixelID: "mx_FB_Pixel_ID",
    CriffTriggered: "mx_Criff_Triggered",
    criffResponse: "mx_Criff_Response_Message",
    pan: "mx_PAN",

    User_Agent: "mx_Lead_Device",

    CompanyType: "mx_Company_Type",
    ModeOfLead: "Source",
    employerName: "mx_Company_Name",
    solId: "mx_Sol_ID",
    Branch_Name: "mx_Branch",
    State: "mx_State",
    State2: "mx_Director_Name",
    // assignToDista: "mx_Negative_Pincode",
    source: "Source",
    interestedProduct: "mx_Interested_Products",
    corporateType: "mx_Corporate_Type",
    journeyType: "mx_Journey_Type",
    emailVerified: "mx_Karza_Email",
    utm_medium: "SourceMedium",
    utm_source: "mx_Source_UTM",
    utm_channel: "mx_UTM_Channel",
    utm_campaigntype: "mx_UTM_Campaigntype",
    utm_campaign: "SourceCampaign",
    utm_content: "SourceContent",
    utm_term: "mx_Utm_Terms",
    utm_lms: "mx_utm_lms",
    utm_matchtype: "mx_UTM_Matchtype",
    utm_placement: "mx_UTM_Placement",
    utm_adgroup: "mx_Ad_Group",
    utm_aud: "mx_utm_aud",
    gbraid: "mx_GBRAID",
    wbraid: "mx_WBRAID",
    gad_source: "mx_test3",
    gad_campaignid: "mx_test4",
    topCorporate: "mx_TopCorporatesEligibleFor",
    annualIncome: "mx_Take_Home_Salary",
    gcc: "mx_GCC_Eligible_For",
    hashedMobile: "mx_Enc_Phone",
    hashedEmail: "mx_ENC_Mail",
    collegeName: "mx_Institute",
    dob: "mx_Date_of_Birth",
    age: "mx_Risk_Score",
    negativePincode :"mx_Salary_Negative_Pincode"

  };
  let LeadBody = [];
  // if (TypeOfLoan == "HL") {
  Object.keys(Config).forEach((key) => {
    if (formData.hasOwnProperty(key) && formData[key])
      LeadBody.push({
        Attribute: Config[key],
        Value: formData[key],
      });
  });
  // }
  return LeadBody;
}

function getCIBILleadBody(formData) {
  let Config = {
    // firstName: "FirstName",
    // emailIs: "EmailAddress",
    // mobileNumer: "Mobile",
    fullName: "mx_TU_Name",
    birthDate: "mx_TU_Date_of_Birth",
    gender: "mx_TU_Gender",
    idNumber: formData.schemaIDName,
    telephoneNumber: "mx_TU_Telephone_1",
    telephoneNumber2: "mx_TU_Telephone_2",
    emailID: "mx_TU_Email_1",
    emailID2: "mx_TU_Email_2",
    // address: "mx_TU_Address_1",
    // address2: "mx_TU_Address_2",
    scoreDate: "mx_TU_CIBIL_Score_Date",
    cibilBandScore: "mx_TU_CIBIL_Band_Score",
    scoreDate2: "mx_TU_Income_Estimator_Date",
    incomeSegmentScore: "mx_TU_Income_Estimator_Score",
    totalAccounts: "mx_TU_Total_Accounts",
    totalInquiry: "mx_TU_Total_Inquiry",
    IsEligible: "mx_Eligible",
  };
  let LeadBody = [];
  // if (TypeOfLoan == "HL") {
  Object.keys(Config).forEach((key) => {
    if (formData.hasOwnProperty(key) && formData[key])
      LeadBody.push({
        Attribute: Config[key],
        Value: formData[key],
      });
  });
  // }
  return LeadBody;
}

const dateFormater = (dateStr) => {
  if (!dateStr) {
    return "";
  }
  // const dateStr = "29042023";
  const day = dateStr.substr(0, 2);
  const month = dateStr.substr(2, 2);
  const year = dateStr.substr(4, 4);

  const formattedDateStr = `${year}-${month}-${day}`;

  // console.log(formattedDateStr);
  return formattedDateStr;
};

function checkEligibility(score) {
  // console.log("score", score);
  if (score === 112 || score === 785) {
    return "No";
  } else {
    return "Yes";
  }
}

export function getEligibility(data) {
  // Iterate over each item in the data
  for (let i = 0; i < data.length; i++) {
    const item = data[i];

    // Check if the attribute is "mx_TU_CIBIL_Band_Score"
    if (item.Attribute === "mx_Eligible") {
      const eligiblity = item.Value;
      // console.log("eligiblity", eligiblity);
      return eligiblity;
      // Check the condition and return the result accordingly
      // if (cibilScore === 112 || cibilScore === 785) {
      //   return "No";
      // } else {
      //   return "Yes";
      // }
    }
  }

  // Return "NA" if the attribute is not found
  return "Yes";
}

export async function concatenateArrays(lsqInputs, customCibilResponse) {
  var mergedArray = lsqInputs.concat(customCibilResponse);
  // Do something with the merged array
  return mergedArray;
  // Next line of code or further processing
}


export function getFirstNameLastName(name) {
  const names = name.split(" ");
  const firstName = names[0];
  const lastName = names.length > 1 ? names[names.length - 1] : "";

  return {
    firstName,
    lastName,
  };
}

export function getScores(criffResponse) {
  const criffMessage = criffResponse?.data?.message;

  const incomeSegmentScore = criffMessage.incomeSegmentScore || "NA"
  const cibilScore = criffMessage.cibilScore || "NA"
  // console.log("criffMessage", criffMessage);

  return { incomeSegmentScore, cibilScore };
}


// Generate Random String for Session Key and IV
const generateRandomString = (length) => {
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  return Array.from(array, byte => ('0' + (byte % 256)).slice(-2)).join('').slice(0, length);
};

// RSA Encryption Function with Dynamic Public Key Fetch
const rsaEncryptSessionKey = async (sessionKey) => {
  try {
    const publicKeyPem = process.env.REACT_APP_ICICI_PUBLIC_KEY;
    if (!publicKeyPem) {
      throw new Error("Public key not found in environment variables");
    }

    // Convert PEM to CryptoKey
    const publicKey = await crypto.subtle.importKey(
      "spki",
      pemToArrayBuffer(publicKeyPem),
      {
        name: "RSA-OAEP",
        hash: "SHA-256"
      },
      true,
      ["encrypt"]
    );

    // Encrypt the session key
    const encryptedKey = await crypto.subtle.encrypt(
      { name: "RSA-OAEP" },
      publicKey,
      new TextEncoder().encode(sessionKey)
    );

    return bufferToBase64(encryptedKey);
  } catch (error) {
    console.error('Failed to load or encrypt with public key:', error);
    throw error;
  }
};

// AES Encryption Function using Web Crypto API
const aesEncrypt = async (data, sessionKey, iv) => {
  // Convert session key and IV to ArrayBuffer
  const key = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(sessionKey),
    { name: "AES-CBC" },
    false,
    ["encrypt"]
  );

  const encryptedData = await crypto.subtle.encrypt(
    {
      name: "AES-CBC",
      iv: new TextEncoder().encode(iv)
    },
    key,
    new TextEncoder().encode(data)
  );

  return new Uint8Array(encryptedData);
};

// Utility: Convert PEM to ArrayBuffer
function pemToArrayBuffer(pem) {
  const base64 = pem.replace(/-----BEGIN PUBLIC KEY-----|-----END PUBLIC KEY-----|\n/g, '');
  const binary = atob(base64);
  const buffer = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    buffer[i] = binary.charCodeAt(i);
  }
  return buffer.buffer;
}

// Utility: Convert ArrayBuffer to Base64
function bufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  return btoa(String.fromCharCode.apply(null, bytes));
}

// Main Encryption Function that can be called externally
export const encryptBody = async (payload) => {
  const sessionKey = generateRandomString(16);  // 16-byte session key
  const iv = generateRandomString(16);  // 16-byte IV for AES

  // Encrypt session key with RSA using the fetched public key
  const encryptedSessionKey = await rsaEncryptSessionKey(sessionKey);

  // Encrypt the payload with AES
  const encryptedDataArrayBuffer = await aesEncrypt(JSON.stringify(payload), sessionKey, iv);

  // Combine IV with encrypted data
  const encryptedData = new Uint8Array(16 + encryptedDataArrayBuffer.byteLength);
  encryptedData.set(new TextEncoder().encode(iv), 0); // First 16 bytes are IV
  encryptedData.set(new Uint8Array(encryptedDataArrayBuffer), 16); // Rest is encrypted data

  // Return the encrypted session key and data
  return {
    requestId: '',
    service: '',
    encryptedKey: encryptedSessionKey,
    encryptedData: bufferToBase64(encryptedData),
    oaepHashingAlgorithm: 'NONE',
    iv: '',
    clientInfo: '',
    optionalParam: ''
  };
}